export const brandList = [
    { gid: "100001", brand: "PP" },
    { gid: "100002", brand: "PP" },
    { gid: "100003", brand: "PP" },
    { gid: "100005", brand: "PP" },
    { gid: "100006", brand: "PP" },
    { gid: "100007", brand: "PP" },
    { gid: "100008", brand: "PP" },
    { gid: "100009", brand: "PP" },
    { gid: "100010", brand: "PP" },
    { gid: "100011", brand: "PP" },
    { gid: "100012", brand: "PP" },
    { gid: "100013", brand: "PP" },
    { gid: "100014", brand: "PP" },
    { gid: "100015", brand: "PP" },
    { gid: "100016", brand: "PP" },
    { gid: "100017", brand: "PP" },
    { gid: "100019", brand: "PP" },
    { gid: "100022", brand: "PP" },
    { gid: "200001", brand: "PP" },
    { gid: "200002", brand: "pg" },
    { gid: "200003", brand: "pg" },
    { gid: "200004", brand: "pg" },
    { gid: "200005", brand: "pg" },
    { gid: "200006", brand: "pg" },
    { gid: "200007", brand: "pg" },
    { gid: "200008", brand: "pg" },
    { gid: "200009", brand: "pg" },
    { gid: "200010", brand: "pg" },
    { gid: "200011", brand: "pg" },
    { gid: "200012", brand: "pg" },
    { gid: "200013", brand: "pg" },
    { gid: "200014", brand: "pg" },
    { gid: "200015", brand: "pg" },
    { gid: "200016", brand: "pg" },
    { gid: "200017", brand: "pg" },
    { gid: "200018", brand: "pg" },
    { gid: "200019", brand: "pg" },
    { gid: "200020", brand: "pg" },
    { gid: "200023", brand: "pg" },
    { gid: "200024", brand: "pg" },
    { gid: "200025", brand: "pg" },
    { gid: "200026", brand: "pg" },
    { gid: "200028", brand: "pg" },
    { gid: "200030", brand: "pg" },
    { gid: "200033", brand: "pg" },
    { gid: "200035", brand: "pg" },
    { gid: "200036", brand: "pg" },
    { gid: "200037", brand: "pg" },
    { gid: "200038", brand: "pg" },
    { gid: "200039", brand: "pg" },
    { gid: "200041", brand: "pg" },
    { gid: "300001", brand: "jili" },
    { gid: "300002", brand: "jili" },
    { gid: "300003", brand: "jili" },
    { gid: "300004", brand: "jili" },
    { gid: "300005", brand: "jili" },
    { gid: "300006", brand: "jili" },
    { gid: "300007", brand: "jili" },
    { gid: "300008", brand: "jili" },
    { gid: "300009", brand: "jili" },
    { gid: "300010", brand: "jili" },
    { gid: "300011", brand: "jili" },
    { gid: "300012", brand: "jili" },
    { gid: "300013", brand: "jili" },
    { gid: "300014", brand: "jili" },
    { gid: "300015", brand: "jili" },
    { gid: "300019", brand: "jili" },
    { gid: "400001", brand: "fac" },
    { gid: "400002", brand: "fac" },
    { gid: "400003", brand: "fac" },
    { gid: "400004", brand: "fac" },
    { gid: "400005", brand: "fac" },
    { gid: "400006", brand: "fac" },
    { gid: "400007", brand: "fac" },
    { gid: "400008", brand: "fac" },
    { gid: "400009", brand: "fac" },
    { gid: "400012", brand: "fac" },
    { gid: "600001", brand: "9f" },
    { gid: "600002", brand: "9f" },
    { gid: "600003", brand: "9f" },
    { gid: "600004", brand: "9f" },
];

export const vipImages = [
    { leve: 1, src: "/vip/1.png", color: "#686868" },
    { leve: 2, src: "/vip/2-3-4.png", color: "#844C4F" },
    { leve: 3, src: "/vip/2-3-4.png", color: "#844C4F" },
    { leve: 4, src: "/vip/2-3-4.png", color: "#844C4F" },
    { leve: 5, src: "/vip/5-6-7.png", color: "#707386" },
    { leve: 6, src: "/vip/5-6-7.png", color: "#707386" },
    { leve: 7, src: "/vip/5-6-7.png", color: "#707386" },
    { leve: 8, src: "/vip/8-9-10.png", color: "#894622" },
    { leve: 9, src: "/vip/8-9-10.png", color: "#894622" },
    { leve: 10, src: "/vip/8-9-10.png", color: "#894622" },
];
